import React from "react"

// Components
import MainCard from "../main-card"
import DotLoading from "../dot-loading"

// Mui
import { Stack, Typography } from "@mui/material"

// ---------------------------------------|| DESKTOP LOADING - COMPONENTS ||-----------------------------------------

const DesktopLoading = () => {
  return (
    <Stack
      direction='row'
      justifyContent='center'
      sx={{ position: "absolute", top: "50%", left: "60%", transform: "translate(-50%, -50%)" }}
    >
      <MainCard shadow={3} sx={{ px: 6, py: 3, borderRadius: "18px" }}>
        <Stack spacing={2}>
          <Typography textAlign='center' color='primary' variant='h5' fontWeight='bold'>
            جت وام
          </Typography>
          <Stack direction='row' justifyContent='center'>
            <DotLoading color='primary' />
          </Stack>
        </Stack>
      </MainCard>
    </Stack>
  )
}

export default DesktopLoading
